import React from "react";

export const useStartRecording = (
  isRecording,
  remoteRef,
  mediaRecorderRef,
  chunksRef,
  setIsRecording,
  resetElapsedTime,
  handleLogs,
) => {
  const startRecording = React.useCallback(() => {
    if (!remoteRef.current || !remoteRef.current.srcObject) return;
    if (isRecording) return;

    try {
      const stream = remoteRef.current.srcObject;
      const getSupportedMimeType = () => {
        const types = [
          "video/webm;codecs=vp9,opus",
          "video/webm;codecs=vp8,opus",
          "video/webm",
          "video/mp4;codecs=h264,mp4a.40.2",
          "video/mp4",
        ];
        return types.find((type) => MediaRecorder.isTypeSupported(type)) || "";
      };

      const options = { mimeType: getSupportedMimeType() };
      mediaRecorderRef.current = new MediaRecorder(stream, options);

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
      resetElapsedTime();
      handleLogs("Recording started (Remote stream)");
    } catch (error) {
      console.error("Error starting recording:", error);
      handleLogs("Error starting recording: " + error.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLogs, isRecording]);
  return { startRecording };
};
